import type {
  ICustomToolBar,
  IErrorApiProps,
  IWorkItemOption,
  TableHeadersType,
} from '../../types';

export enum EEnvironments {
  DEV = 'DEV',
  PROD = 'PROD',
  TEST = 'TEST',
  ACC = 'ACC',
}

export enum EBrowserType {
  Chrome = 'Chrome',
  Edge = 'Edge',
  Safari = 'Safari',
}

export enum ELocalStore {
  IsUnSupportedBrowserAck = 'isUnsBrowAck',
}

export enum ECellType {
  Feature = 'feature',
  Option = 'option',
  Flag = 'flag',
  Quote = 'quote',
  Reset = 'reset',
  Status = 'status',
  SaveStatus = 'saveStatus',
  Boolean = 'boolean',
  Date = 'date',
  Link = 'link',
}

export enum EDataTableType {
  Features = 'features',
  Product = 'product',
  MultiNumeric = 'multiNumeric',
  AllPropertiesHistory = 'allPropertiesHistory',
  PropertyHistory = 'propertyHistory',
}

export enum EPageType {
  Home = 'Home',
}

export enum EPageName {
  Home = '/',
  Procos = '/procos',
  Feature = '/features',
  Pdm = '/pdm',
  Category = '/categories',
  Manage = '/manage',
}

export enum ERuleType {
  Market = 'MRKT',
}

export enum EPropertyType {
  Boolean = 'BOOL',
  Numeric = 'NUM',
  String = 'STR',
  Enum = 'ENUM',
  Single = 'SNG',
  Multiple = 'MUL',
}

export enum EPropertyApplicability {
  Master = 'MSTR',
  Feature = 'FTR',
  Option = 'OPT',
  Product = 'PROD',
  String = 'STR',
  Numeric = 'NUM',
}

export enum EMasterPropertyCodes {
  AgCode = 'AGC',
}

export enum EFeatureFamilyType {
  String = 'String',
  Numeric = 'Numeric',
  Feature = 'Feature',
}

export enum ECommonDialogType {
  HomeClickWarning = 'HomeClickWarning',
  Success = 'Success',
  MultiNumericManipulation = 'multiNumericManipulation',
  Error = 'Error',
  Confirm = 'Confirm',
  Unknown = 'Unknown',
}

export enum EPropertyGroup {
  Master = 'Master',
  Product = 'Product',
  Download = 'Download',
}

export enum EFeatureStatus {
  Active = 'Active',
  InActive = 'InActive',
}

export enum EDropCategory {
  Assigned = 'assigned',
  Unassigned = 'unassigned',
  Category = 'category',
  Section = 'section',
}

export enum EApiType {
  SaveProperties = 'saveProperties',
  SaveMarketAssociations = 'saveMarketAssociations',
  SendNotification = 'sendNotification',
  Download = 'download',
  GetPropertyAssociations = 'getPropertyAssociations',
}

export enum EConfirmDialog {
  RemoveEmptySection = 'removeEmptySection',
  DiscardChanges = 'discardChanges',
  DeleteSection = 'deleteSection',
  SaveRequired = 'saveRequiredForObsoleteFeature',
}

export enum EPrimitiveType {
  String = 'string',
}

export const InludeCodeInView = true;

export const ExcludeColumnFilters = ['flag', 'reset'];

export const TableField = {
  feature: 'feature',
  option: 'option',
  type: 'type',
  rfq: 'RfQ_',
  flag: 'flag',
  code: 'code',
  country: 'country',
  quote: 'quote',
  status: 'status',
  saveStatus: 'saveStatus',
  isActive: 'isActive',
  name: 'name',
  isLocal: 'isLocal',
  createdOn: 'createdOn',
  modifiedOn: 'modifiedOn',
  createdBy: 'createdBy',
  modifiedBy: 'modifiedBy',
  propertyCode: 'propertyCode',
  associationType: 'associationType',
  featureCode: 'featureCode',
  optionCode: 'optionCode',
  action: 'action',
  oldValue: 'oldValue',
  newValue: 'newValue',
};

export const TableHeaders: TableHeadersType = {
  features: [
    { field: TableField.isActive, width: 80, cellType: ECellType.Status, align: 'center' },
    { field: TableField.saveStatus, width: 10, cellType: ECellType.SaveStatus, align: 'center' },
    { field: TableField.feature, width: 180, cellType: ECellType.Feature },
    { field: TableField.option, width: 180, cellType: ECellType.Option },
    { field: TableField.type, width: 65 },
    { field: 'reset', width: 65, cellType: ECellType.Reset, align: 'center' },
  ],
  product: [
    { field: TableField.flag, width: 50, cellType: ECellType.Flag },
    { field: TableField.code, width: 150, sortable: true, align: 'center' },
    { field: TableField.country, width: 250, sortable: true, headerAlign: 'left' },
    { field: TableField.quote, width: 100, cellType: ECellType.Quote, align: 'center' },
  ],
  multiNumeric: [
    { field: TableField.code, width: 150, sort: true, searchable: true, type: ECellType.Link },
    { field: TableField.name, width: 150, sort: true, searchable: true },
    { field: TableField.isLocal, width: 100, sort: true, type: ECellType.Boolean },
    { field: TableField.isActive, width: 100, sort: true, type: ECellType.Boolean },
    { field: TableField.createdOn, width: 180, sort: true, type: ECellType.Date },
    { field: TableField.modifiedOn, width: 180, sort: true, type: ECellType.Date },
    { field: TableField.createdBy, width: 180, sort: true },
    { field: TableField.modifiedBy, width: 180, sort: true },
  ],
  allPropertiesHistory: [
    { field: TableField.propertyCode, width: 120 },
    { field: TableField.associationType, width: 145 },
    { field: TableField.featureCode, width: 120 },
    { field: TableField.optionCode, width: 120 },
    { field: TableField.action, width: 60 },
    { field: TableField.oldValue, width: 120 },
    { field: TableField.newValue, width: 120 },
    { field: TableField.createdBy, width: 200 },
    { field: TableField.createdOn, width: 200, cellType: ECellType.Date },
  ],
  propertyHistory: [
    { field: TableField.action, width: 120 },
    { field: TableField.oldValue, width: 120 },
    { field: TableField.newValue, width: 120 },
    { field: TableField.createdBy, width: 200 },
    { field: TableField.createdOn, width: 200, cellType: ECellType.Date },
  ],
};

export const popperModifier = [
  {
    name: 'flip',
    enabled: false,
    options: {
      altBoundary: false,
      rootBoundary: 'viewport',
    },
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      rootBoundary: 'document',
    },
  },
];

export enum ETabName {
  PDM = 'pdm',
  ProCos = 'procos',
  Category = 'categories',
}

export const TabList = {
  Home: [
    {
      id: 'product',
      name: 'labels.product',
      path: EPageName.Home,
    },
    {
      id: 'manage',
      name: 'labels.manage',
      path: EPageName.Manage,
    },
  ],
  Pdm: [
    {
      id: ETabName.ProCos,
      name: 'labels.procos',
      path: EPageName.Procos,
    },
    {
      id: ETabName.PDM,
      name: 'labels.pdm',
      path: EPageName.Pdm,
    },
    {
      id: ETabName.Category,
      name: 'labels.categories',
      path: EPageName.Category,
    },
  ],
};

export const ProcosTabs = [
  { id: 'product', name: 'labels.product', path: '' },
  { id: 'option', name: 'labels.option', path: 'features' },
];

export const MultinumericTabs = [
  { id: 'multinumeric', name: 'labels.multiNumeric', path: 'manage' },
];

export const DefaultProcosTab = 'procos';

export const Master: IWorkItemOption = { id: '0', name: 'Master' };

export const DefaultLanguage = {
  code: 'en-US',
  name: 'English',
};

export const Languages = [
  { code: 'en-US', name: 'English' },
  { code: 'fr-FR', name: 'French' },
  { code: 'de-DE', name: 'German' },
  { code: 'it-IT', name: 'Italian' },
];

export const Status = {
  Active: 'active',
  InActive: 'inActive',
};

export const FeatureTypeFilters = [
  { value: 'String', label: 'String' },
  { value: 'Numeric', label: 'Numeric' },
  { value: 'Feature', label: 'Feature' },
];

export const DefaultAssignmentIcon = 'D';

export enum EFieldSize {
  Small = 'small',
  Large = 'large',
  Medium = 'medium',
}

export enum ERecordLength {
  RL15 = 15,
  RL25 = 25,
  RL50 = 50,
  RL100 = 100,
  RL500 = 500,
}

export const RecordLength = [
  ERecordLength.RL15,
  ERecordLength.RL25,
  ERecordLength.RL50,
  ERecordLength.RL100,
];

export enum EKeyAction {
  Enter = 'Enter',
  Clear = 'clear',
}

export enum EUrlParams {
  ProductId = 'productCode',
  Search = 'search',
  Active = 'active',
  Page = 'Page',
  Limit = 'limit',
}

export enum ECategoryType {
  Standard = 'Standard',
  MultiNumeric = 'MultiNumeric',
  SubmodelView = 'SubmodelView',
}

export enum EToastifyStyle {
  Default = 'default',
  PartialSuccess = 'Partial-Success',
  Failed = 'Failed',
  Success = 'Success',
}

export enum ERuleStrategy {
  Inclusive = 'Inclusive',
  Exclusive = 'Exclusive',
}

export enum ERuleSaveStatus {
  Inprogress = 'P',
  Success = 'S',
  Failed = 'F',
  Partial = 'W',
}

export enum ENotificationType {
  SendToSofon = 'SendToSofon',
}

export enum ENotificationSource {
  PDM = 'PDM',
}

export enum ENotificationApplication {
  Sofon = 'Sofon',
}

export enum ENotificationExecution {
  ProductDataSync = 'ProductDataSync',
}

export enum EWorkItemType {
  Master = 'Master',
  WorkItem = 'WorkItem',
}

export enum EActionType {
  Edit = 'Edit',
  Create = 'Create',
  Delete = 'Delete',
  Add = 'Add',
}

export enum EAction {
  Read = 'read',
  Create = 'create',
  Update = 'update',
  Get = 'get',
}

export const RegExPatterns = {
  Url: /^(https?|ftp):\/\/\w+(\.\w+)*(:\d+)?\/?(\/[.\w]*)*$/,
  Email: /^[\w\-.]+@([\w-]+\.)+[\w-]{2,}$/,
  AlphaNumeric: /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/,
  AlphaNumericUnderscore: /^[A-Za-z0-9]+(_[A-Za-z0-9]+)*$/,
  AplhaNumericHyphenUnderscore: /^[A-Za-z0-9]+(([-_])[A-Za-z0-9]+)*$/,
  AlphaNumericSeperators: /^[A-Za-z0-9]+(([-_:])[A-Za-z0-9]+)*$/,
  LanguageCode: /^[a-zA-Z]{2}-[a-zA-Z]{2}$/,
  MarketCode: /^[a-zA-Z]{2}$/,
  // UserName: /^((\([A-Za-z\s]+\)+(\s+))|([A-Za-z0-9]+(,\s|\s))|[A-Za-z0-9])+[A-Za-z0-9]+((,\s[A-Za-z0-9])|(\s(\([A-Za-z\s]+\))))?$/
};

export enum EHttpCode {
  Status204 = 204,
  Status400 = 400,
  Status401 = 401,
  Status403 = 403,
  Status404 = 404,
}

export enum EErrorCode {
  NetworkError = 'ERR_NETWORK',
  WiInvalid = 'WiInvalid',
}

export const searchFields = ['code', 'name'];

export const ShowOptionCodeForProperties = ['ERO', 'AGC'];

export enum EMessageType {
  Error = 'error',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Default = 'default',
}

export enum EWorkItemStatus {
  InProgress = 'InProgress',
}

export enum ECategoryErrorType {
  INVALID_DRAG_DROP = 'INVALID_DRAG_DROP',
  MULTI_NUMERIC_WARNING = 'MULTI_NUMERIC_WARNING',
}

export const RecordLimit = {
  default: 100,
};

export const ECustomToolBar: ICustomToolBar = {
  multiNumeric: {
    search: true,
    recordsPerPage: true,
    columns: true,
    filter: true,
    refresh: true,
    delete: true,
    add: true,
    customFilterPanel: false,
  },
  allPropertiesHistory: {
    search: false,
    recordsPerPage: true,
    columns: true,
    filter: true,
    refresh: true,
    delete: false,
    add: false,
    customFilterPanel: true,
  },
  propertyHistory: {
    search: false,
    recordsPerPage: true,
    columns: true,
    filter: true,
    refresh: true,
    delete: false,
    add: false,
    customFilterPanel: true,
  },
};

export enum EAssociationType {
  Boolean = 'Boolean',
  String = 'String',
  Enum = 'Enum',
  Number = 'Number',
}

export enum EPropertyActionType {
  Update = 'Update',
  Add = 'Add',
  Delet = 'Delete',
}

export const EDisabledProperties = {
  [EPropertyApplicability.Product]: ['CHT'],
};

export enum EDisplayType {
  Dialog = 'dialog',
  Toast = 'toast',
  None = 'none',
}

/**
 * Global HTTP error message keys (ultimate fallback).
 * If an action's config doesn't define a message for a status code,
 * this map is used. Maps to 'errorMessages.http.{code}' in translations.
 */
export const GlobalHttpErrorMessageKey = 'messages.http';

/**
 * Configuration map for error feedback per API action.
 * To change behavior: update messages here. No changes to handleError needed.
 */
export const errorConfig: Partial<Record<EApiType, IErrorApiProps>> = {
  [EApiType.SaveProperties]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'messages.submit.error' } },
  },
  [EApiType.SaveMarketAssociations]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'messages.submit.error' } },
  },
  [EApiType.SendNotification]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'request.failed' } },
  },
  [EApiType.Download]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'request.failed' } },
  },
  [EApiType.GetPropertyAssociations]: {
    displayAs: EDisplayType.Toast,
    messages: {
      [EHttpCode.Status204]: {
        message: 'messages.pdm.noPropertyAssociationFound',
        type: EMessageType.Info,
        toastPosition: 'top-center',
      },
      default: {
        message: 'messages.error.fetchPropertyAssociations',
        type: EMessageType.Error,
        toastPosition: 'top-center',
      },
    },
  },
};

export enum EViews {
  Master = 'MASTER',
}
